import { Box, Flex, Heading, Image, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import stepTwoImage from "../../../../../assets/img/issb/step-two-image.png";

function StepTwo() {
  const { t } = useTranslation("translation", {
    keyPrefix: "issbPlan.planDetails.modals.stepTwo"
  });

  return (
    <>
      <Heading size="lg" marginBottom={5}>
        {t("title")}
      </Heading>
      <Flex>
        <Box width="50%">
          <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
            {t("context")}
          </Text>
          <Text fontSize="lg" marginBottom={2}>
            {t("contextContent")}
          </Text>
          <Text fontSize="lg" fontWeight={600} marginBottom={8}>
            {t("notaBene")}
          </Text>
          <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
            {t("actions")}
          </Text>
          <UnorderedList marginLeft={8} marginBottom={8}>
            <ListItem>
              <Text fontSize="lg">
                {t("actionsContent.actionOne")}
              </Text>
            </ListItem>
            <ListItem>
              <Text fontSize="lg">
                {t("actionsContent.actionTwo")}
              </Text>
            </ListItem>
            <ListItem>
              <Text fontSize="lg">
                {t("actionsContent.actionThree")}
              </Text>
            </ListItem>
          </UnorderedList>
          <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
            {t("data")}
          </Text>
          <Text fontSize="lg" marginBottom={8}>
            {t("dataContent")}
          </Text>
          <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
            {t("stakeholders")}
          </Text>
          <Text fontSize="lg" marginBottom={8}>
            {t("stakeholdersContent")}
          </Text>
          <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
            {t("esg360Support")}
          </Text>
          <Text fontSize="lg" marginBottom={4}>
            {t("esg360SupportContent")}
          </Text>
        </Box>
        <Box width="50%">
          <Image height={"400px"} src={stepTwoImage} />
        </Box>
      </Flex>
    </>
  );
}

export default StepTwo;